import {
  canExtendCommercialTrial,
  getTrialDaysRemaining,
  getTrialExpiryTime,
  isTrialExpired,
  mergeTrialAttributes,
  type TrialAttributeOverrides,
} from './trialUtils';

const PREFIX = '[trial-debug]';

export const extractTrialFieldsFromUser = (user: Record<string, unknown> | null | undefined) => {
  if (!user) {
    return {
      created_at: null,
      extended_trial_days: null,
      allCustomClaims: {},
    };
  }

  const allCustomClaims = Object.fromEntries(
    Object.entries(user).filter(([key]) => key.startsWith('custom:')),
  );

  return {
    created_at: user['custom:created_at'] ?? null,
    extended_trial_days: user['custom:extended_trial_days'] ?? null,
    trial_extended_at: user['custom:trial_extended_at'] ?? null,
    allCustomClaims,
  };
};

export const logTrialDebug = (scope: string, data: Record<string, unknown>) => {
  console.groupCollapsed(`${PREFIX} ${scope}`);
  console.log(data);
  console.groupEnd();
};

export const logTrialEvaluation = (
  scope: string,
  params: {
    user: Record<string, unknown> | null | undefined;
    trialAttributes?: TrialAttributeOverrides | null;
    trialType?: string | null;
    extra?: Record<string, unknown>;
  },
) => {
  const jwtFields = extractTrialFieldsFromUser(params.user);
  const mergedUser = mergeTrialAttributes(params.user, params.trialAttributes ?? undefined);
  const mergedFields = extractTrialFieldsFromUser(mergedUser);

  logTrialDebug(scope, {
    ...params.extra,
    trialType: params.trialType ?? null,
    apiTrialAttributes: params.trialAttributes ?? null,
    jwt: jwtFields,
    merged: mergedFields,
    isTrialExpiredJwt: params.user ? isTrialExpired(params.user) : null,
    isTrialExpiredMerged: mergedUser ? isTrialExpired(mergedUser) : null,
    trialExpiryTimeMerged: mergedUser ? new Date(getTrialExpiryTime(mergedUser)).toISOString() : null,
    canExtendCommercialTrial: mergedUser
      ? canExtendCommercialTrial(mergedUser, params.trialType ?? null)
      : null,
    daysRemainingMerged: mergedUser ? getTrialDaysRemaining(mergedUser) : null,
  });
};
